import axios from "axios";
import API from "../helpers/api";
export const getMDDeatil = (id) => {
  let url = `${API.MDDetail}?mddeclarationid=${id}`;
  return dispatch => {
    axios.get(url)
      .then((response) => {
        dispatch({
          type: "GetMDDetailSuccess",
          data: response.data
        })
      })
      .catch((error) => {
        dispatch({
          type: "GetMDDetailFailure",
          error: "ERROR"
        })
      })
  }
}
export const getOthersMI = (id) => {
  let urlother = `${API.MDMaterialInformation}?mddeclarationid=${id}&tabletype=Other`;
  return dispatch => {
    axios.get(urlother)
      .then((response) => {
        dispatch({
          type: "GetOthersMISuccess",
          data: response.data
        })
      })
      .catch((error) => {
        dispatch({
          type: "GetOthersMIFailure",
          error: "ERROR"
        })
      })
  }
}
export const getEuMI = (id) => {
  let urleu = `${API.MDMaterialInformation}?mddeclarationid=${id}&tabletype=EU`;
  return dispatch => {
    axios.get(urleu)
      .then((response) => {
        dispatch({
          type: "GetOthersEUSuccess",
          data: response.data
        })
      })
      .catch((error) => {
        dispatch({
          type: "GetOthersEUFailure",
          error: "ERROR"
        })
      })
  }
}
export const getMDRelatedDocuments = (id) => {
  let url = `${API.MDRelatedDocuments}?mddeclarationid=${id}`;
  return dispatch => {
    axios.get(url)
      .then((response) => {
        dispatch({
          type: "getMDRelatedDocuments",
          data: response.data
        })
      })
      .catch((error) => {
        dispatch({
          type: "GetMDRelatedDocumentsFailure",
          error: "ERROR"
        })
      })
  }
}
export const getMaterialDetails = (type, table, material, threshold) => {
  let urlother = `${API.MasterMaterialInformation}?tabletype=${type}&tablevalue=${table}&thresholdvalue=${threshold}&materialname=${material}`;
  return dispatch => {
    axios.get(urlother)
      .then((response) => {
        dispatch({
          type: "GetMaterialDetailsSuccess",
          data: response.data
        })
      })
      .catch((error) => {
        dispatch({
          type: "GetMaterialDetailsFailure",
          error: "ERROR"
        })
      })
  }
}
export const getMDRemarks = (id) => {
  let urlother = `${API.MDRemarksGet}?mddeclarationid=${id}`;
  return dispatch => {
    axios.get(urlother)
      .then((response) => {
        dispatch({
          type: "GetMDRemarkSuccess",
          data: response.data
        })
      })
      .catch((error) => {
        dispatch({
          type: "GetMDRemarkFailure",
          error: "ERROR"
        })
      })
  }
}